import UserPrivateComponent from "@/components/PrivacyComponent/UserPrivateComponent";
import { useAddInterestMutation } from "@/redux/rtk/features/interest/interestApi";
import { Button, Form, Input } from "antd";
import { useTranslation } from "react-i18next";

export default function AddInterest({ onClose }) {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [addInterest, { isLoading }] = useAddInterestMutation();

  const onFinish = async (values) => {
    const formData = {
      ...values,
    };

    const resp = await addInterest(formData);
    if (resp.data) {
      form.resetFields();
      if (onClose) onClose();
    }
  };

  return (
    <div className="flex justify-center mt-5">
      <UserPrivateComponent permission="create-interest">
        <Form
          className="w-full"
          onFinish={onFinish}
          colon={false}
          layout="vertical"
          form={form}>
          <div className="w-full px-10">
            <Form.Item
              label={t("interest.name")}
              name="name"
              rules={[
                { required: true, message: t("interest.nameRequired") },
              ]}>
              <Input placeholder={t("interest.name")} />
            </Form.Item>
          </div>

          <Form.Item label="" className="px-10">
            <div className="flex items-center gap-2">
              <Button
                size={"large"}
                htmlType="submit"
                type="primary"
                loading={isLoading}>
                {t("common.create")}
              </Button>
            </div>
          </Form.Item>
        </Form>
      </UserPrivateComponent>
    </div>
  );
}
